// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { Control } from '../Control';
import RangeSelectorTemplate from '@front/templates/RangeSelectorTemplate.html';
import { ScrollUtils } from '../../UtilsClasses/ScrollUtils';
export class RangeSelector extends Control {
    constructor() {
        super();
        this.onMouseWheel = (context) => {
            const event = context.event;
            if (!isValidNumber(event.deltaY)) {
                return;
            }
            const isUp = ScrollUtils.IsScrollUp(event.deltaY);
            const currentMoveType = isUp ? 1 : -1;
            const value = this.get('rangeValue');
            const min = this.get('min');
            const max = this.get('max');
            const newValue = Math.min(max, Math.max(min, value + currentMoveType));
            this.onValueChanged(newValue);
            this.updateSliderBackground(newValue);
        };
        this.onChangeValue = (event) => {
            const slider = event.node;
            const value = parseInt(slider.value);
            this.onValueChanged(value);
            this.updateSliderBackground(value);
        };
    }
    oncomplete() {
        super.oncomplete();
        this.on('onChangeValue', this.onChangeValue);
        this.on('onMouseWheel', this.onMouseWheel);
        this.observe('rangeValue', (newValue) => {
            this.updateSliderBackground(newValue);
        });
        this.setLabelsWithLeft();
    }
    updateSliderBackground(value) {
        const min = this.get('min');
        const max = this.get('max');
        const percentage = ((value - min) / (max - min)) * 100;
        void this.set({ backgroundInPercent: percentage });
    }
    setLabelsWithLeft() {
        const labels = this.get('labels');
        const max = this.get('max');
        const min = this.get('min');
        const delta = max - min;
        const labelsWithLeft = [];
        labels.forEach((label, value) => {
            const left = (value * 100) / delta;
            labelsWithLeft.push({ label, left, value });
        });
        void this.set({ labelsWithLeft });
    }
    onValueChanged(newValue) {
        this.fire('changedValue', newValue);
    }
}
Control.extendWith(RangeSelector, {
    template: RangeSelectorTemplate,
    data: function () {
        return {
            rangeValue: 0,
            min: 0,
            max: 100,
            step: 1,
            backgroundInPercent: 0,
            labels: null,
            count: 0,
            labelsWithLeft: []
        };
    }
});
